module.exports = __webpack_public_path__ + "static/trust-partner-img-534e9f5f0c4890980d590c44228793ec.svg";